export function parseCisProContainerIds(value: string | null | undefined): string[] {
  return (value ?? '')
    .split(',')
    .map(barcode => barcode.trim())
    .filter(Boolean);
}

export function normalizeCisProContainerId(value: string): string {
  return value.toUpperCase();
}

export function addDisposedCisProContainerIds(
  disposedContainerIds: Set<string>,
  value: string | null | undefined
): void {
  for (const barcode of parseCisProContainerIds(value)) {
    disposedContainerIds.add(normalizeCisProContainerId(barcode));
  }
}

export function setCisProContainerDisposedState(
  disposedContainerIds: Set<string>,
  value: string | null | undefined,
  isDisposed: boolean
): void {
  for (const barcode of parseCisProContainerIds(value)) {
    const normalizedBarcode = normalizeCisProContainerId(barcode);
    if (isDisposed) {
      disposedContainerIds.add(normalizedBarcode);
    } else {
      disposedContainerIds.delete(normalizedBarcode);
    }
  }
}

export function hasDisposedCisProContainer(
  value: string | null | undefined,
  disposedContainerIds: ReadonlySet<string>
): boolean {
  return parseCisProContainerIds(value)
    .some(barcode => disposedContainerIds.has(normalizeCisProContainerId(barcode)));
}

export function getCisProContainerTooltip(
  value: string | null | undefined,
  disposedContainerIds: ReadonlySet<string>,
  multipleContainers: boolean
): string {
  const barcodeText = value ?? '';
  if (!hasDisposedCisProContainer(barcodeText, disposedContainerIds)) {
    return barcodeText;
  }

  return multipleContainers
    ? `${barcodeText} - Container(s) Disposed!`
    : `${barcodeText} Container Disposed!`;
}
